/** Pilot document download URL (query param — nginx blocks %2F in path segments). */
export function pilotDocumentFetchUrl(docPath) {
  if (!docPath) return '';
  return `/api/upload/file?${new URLSearchParams({ path: String(docPath) }).toString()}`;
}
